import getters from './getters'
import mutations from './mutations'

export default {
  state: {
    rememberMe: false,
    login: null,
    password: null,
    isError: false,
  },
  getters: getters,
  mutations: mutations,
}
